import { Controller } from "stimulus"

// Dispara o download do Resumo do Pedido sem abrir aba nova.
//
// O PDF é gerado no front React (react-pdf, no browser) — esta tela não tem
// como gerá-lo. Como o OMS legado roda dentro de um iframe do shell React,
// publicamos a intenção para a janela pai via postMessage e é ela quem busca o
// pedido, gera o arquivo e dispara o download (ver
// OrderSummaryDownloadBridge.tsx no front).
//
// Fora do shell (tela legada aberta direto, sem janela pai) não há ponte
// possível: caímos na página de impressão do front em aba nova.
export default class extends Controller {
  download = event => {
    event.preventDefault()

    const targetOrigin = this.targetOrigin()

    if (!targetOrigin || !this.isEmbedded()) {
      window.open(this.data.get('fallbackUrl'), '_blank')
      return
    }

    window.parent.postMessage({
      type: 'oms:download-order-summary',
      orderId: this.data.get('orderId'),
      format: this.data.get('format'),
      signature: this.data.get('signature') === 'true'
    }, targetOrigin)
  }

  isEmbedded = () => window.parent && window.parent !== window

  // O host do front vem do ENV OMS_REACT_HOST, que pode incluir path/barra
  // final; postMessage exige apenas a origem.
  targetOrigin = () => {
    try {
      return new URL(this.data.get('targetOrigin')).origin
    } catch (error) {
      return null
    }
  }
}
